import React, { useState } from "react";
import styles from "./WaveInput.module.scss";

export interface WaveInputProps
  extends Omit<React.InputHTMLAttributes<HTMLInputElement>, "className"> {
  label: string;
  error?: boolean;
  errorMessage?: string;
  icon?: React.ReactNode;
}

const WaveInput = React.forwardRef<HTMLInputElement, WaveInputProps>(
  ({ label, error, errorMessage, icon, value, id, type = "text", onFocus, onBlur, ...rest }, ref) => {
    const hasValue = Boolean(value && String(value).length > 0);
    const [isFocused, setIsFocused] = useState(false);
    const inputId = id || `wave-input-${label.replace(/\s/g, "-")}`;
    const isFloating = hasValue || isFocused;

    const handleFocus = (e: React.FocusEvent<HTMLInputElement>) => {
      setIsFocused(true);
      onFocus?.(e);
    };

    const handleBlur = (e: React.FocusEvent<HTMLInputElement>) => {
      setIsFocused(false);
      onBlur?.(e);
    };

    return (
      <div
        className={`${styles.waveGroup} ${
          isFloating ? styles.waveGroupFloating : ""
        } ${error ? styles.waveGroupError : ""}`}
      >
        {icon && <div className={styles.iconWrapper}>{icon}</div>}
        <input
          ref={ref}
          id={inputId}
          type={type}
          value={value}
          onFocus={handleFocus}
          onBlur={handleBlur}
          className={`${styles.waveInput} ${icon ? styles.withIcon : ""} ${
            error ? styles.error : ""
          }`}
          {...rest}
        />
        <label
          htmlFor={inputId}
          className={`${styles.waveLabel} ${icon ? styles.withIcon : ""}`}
        >
          {label}
        </label>
        <span className={styles.waveBar} />
        {error && errorMessage && (
          <span className={styles.waveError}>{errorMessage}</span>
        )}
      </div>
    );
  }
);

WaveInput.displayName = "WaveInput";

export default WaveInput;
